<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DYNAMIC HIERARCHY
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title class="primary py-2">
          <v-flex xs9 class="white--text">
            <span class="fs-18">Structure {{ items.name }}</span>
          </v-flex>
        </v-card-title>
        <org-chart :datasource="items" pan></org-chart>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs1 right>
            <v-btn
              id="btn-cancel"
              dark
              rounded
              color="red"
              block
              @click="goBack()"
            >
              Back
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../mixins/ACLMixin';
// import paginationMixin from '../../mixins/paginationMixin';
import OrgChart from 'vue-organization-chart';
import 'vue-organization-chart/dist/orgchart.css';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    OrgChart
  },
  mixins: [ACLMixin],
  props: ['id'],
  data() {
    return {
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'Organization Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Structure Detail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      items: {},
      isDraft: false
    };
  },
  mounted() {
    this.checkDraft();
    this.getDetail();
  },
  methods: {
    checkDraft() {
      let path = this.$route.path;
      let type = path.split('/');
      if (type[2] === 'draft') {
        this.isDraft = true;
      } else {
        this.isDraft = false;
      }
    },
    getDetail() {
      this.progressDialogLoading = true;
      let endpoint = '';
      if (this.isDraft) {
        endpoint = 'dynamic/detailDraftHierarchy';
      } else {
        endpoint = 'dynamic/detailHierarchy';
      }
      this.$store
        .dispatch(endpoint, this.id)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            if (!this.isDraft) {
              this.items = data.data;
            } else {
              this.items = {
                id: data.data.division_id,
                name: data.data.hierarchy.name,
                children: data.data.hierarchy.children
              };
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    goBack() {
      this.$router.push({
        name: this.isDraft ? 'draft-hierarchy' : 'dynamic-hierarchy'
      });
    }
  }
};
</script>
